__turbopack_context__.v({
  "CheckboxIndicator": "Checkbox-module__aXg1zW__CheckboxIndicator",
  "enabled": "Checkbox-module__aXg1zW__enabled",
  "lc-checkbox": "Checkbox-module__aXg1zW__lc-checkbox",
});
